module.exports = __webpack_public_path__ + "img/meipire_5.60f8d928.png";